<template>
  <v-container fluid>  
    <v-layout align-center justify-center>
      
      <v-flex md10 sm12>
        
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>